import React from 'react';
import { Link } from 'react-router-dom';
import CellWithIcon from './CellWithIcon';

function CellWithHyperlinkIcon({
    type, href, size = 20, className = '',
}) {
    const cellWithIcon = CellWithIcon(type, size);

    return (
        <Link to={{ pathname: href }} target="_parent" className={className}>
            {cellWithIcon}
        </Link>
    );
}


export default CellWithHyperlinkIcon;
